export default __webpack_public_path__ + "static/media/warning--traffic-slow--g1.169e23bf.png";